export default function() {
  const widgetName = 'cardWidgetHotButtons';
  const widgetOpts = cardWidgetHotButtonsOpts;

  const widgetHeadline = "<h2>Explore Peoples Federal Credit Union</h2>";
  $(widgetHeadline).insertBefore(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function(i) {
        $(this).find('.card-content').attr('data-title', data.items[i].Title);
      });

      function hotButtonFadeIn() {
        let options = {
          threshold: 0.25,
        }
        let intersectionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // element is in viewport, do the stuff
              // console.log(entry.isIntersecting)
              $(`#${widgetName} .card-widget-item`).each(function(i) {
                let $t = $(this);
                $t.css('transition-delay', `${0.25*i}s`)
                $t.addClass('animate__slide-in-left');
              });
              // it's good to remove observer,
              // if you don't need it any more
              observer.unobserve(entry.target);
            }
          });
        }, options);
        
        // start observing your elements
        intersectionObserver.observe(document.getElementById('cardWidgetHotButtons'));
      }

      if ('IntersectionObserver' in window) {
        $(`#${widgetName}`).addClass('io-supported');
        hotButtonFadeIn();
      }

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 6,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: true
  });

}